import { useState } from "react";
import {
  Container,
  Row,
  Col,
  Badge,
  Button,
  Card,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import programm from "./../../../assets/app.apk"

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800&family=DM+Sans:wght@300;400;500&display=swap');

  :root {
    --bg: #f7f5ff76;
    --bg2: #ffffff;
    --bg3: #f0eefe;
    --acc: #5b4ef5;
    --acc2: #7c6ff7;
    --acc3: #059669;
    --acc-light: #ede9fe;
    --acc-light2: #ddd6fe;
    --txt: #1a1333;
    --txt2: #5b5471;
    --txt3: #9890b8;
    --border: #e4e0f7;
    --shadow: rgba(91, 78, 245, 0.10);
  }

  .adp-root {
    font-family: 'DM Sans', sans-serif;
    background: var(--bg);
    color: var(--txt);
    min-height: 100vh;
    position: relative;
    overflow-x: hidden;
  }

  .adp-root h1, .adp-root h2, .adp-root h3,
  .adp-root h4, .adp-root .syne {
    font-family: 'Syne', sans-serif;
  }

  .adp-page-bg {
    position: fixed;
    inset: 0;
    z-index: 0;
    pointer-events: none;
    background:
      radial-gradient(ellipse 70% 50% at 10% 0%, #c4b5fd40 0%, transparent 60%),
      radial-gradient(ellipse 50% 40% at 90% 90%, #a7f3d040 0%, transparent 55%),
      radial-gradient(ellipse 40% 35% at 70% 20%, #e0d7fe30 0%, transparent 50%);
  }

  .adp-wrap {
    position: relative;
    z-index: 1;
    padding: 3rem 0 5rem;
  }

  /* Badge pill */
  .adp-badge-pill {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    background: var(--acc-light);
    border: 1.5px solid var(--acc-light2);
    border-radius: 100px;
    padding: 6px 16px;
    font-size: 11.5px;
    font-weight: 600;
    color: var(--acc);
    letter-spacing: .05em;
    text-transform: uppercase;
    margin-bottom: 1.4rem;
    animation: adpFadeDown .5s ease both;
  }
  .adp-badge-pill .dot {
    width: 7px; height: 7px;
    border-radius: 50%;
    background: var(--acc3);
    box-shadow: 0 0 0 3px #a7f3d060;
    animation: adpPulse 2s infinite;
  }

  /* Hero */
  .adp-hero-title {
    font-size: clamp(2.4rem, 6.5vw, 4.2rem);
    font-weight: 800;
    line-height: 1.05;
    letter-spacing: -.03em;
    color: var(--txt);
    animation: adpFadeDown .55s .08s ease both;
  }
  .adp-hero-title span {
    background: linear-gradient(135deg, var(--acc), var(--acc2) 60%, #a78bfa);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .adp-hero-sub {
    font-size: 1.05rem;
    color: var(--txt2);
    font-weight: 300;
    line-height: 1.75;
    margin-top: 1rem;
    animation: adpFadeDown .55s .16s ease both;
  }
  .adp-stats-row {
    display: flex;
    gap: 2.5rem;
    flex-wrap: wrap;
    margin-top: 2rem;
    animation: adpFadeDown .55s .22s ease both;
  }
  .adp-stat-num {
    font-family: 'Syne', sans-serif;
    font-size: 1.5rem;
    font-weight: 700;
    color: var(--txt);
  }
  .adp-stat-lbl {
    font-size: .75rem;
    color: var(--txt3);
    text-transform: uppercase;
    letter-spacing: .07em;
    margin-top: 2px;
  }

  /* Phone mockup */
  .adp-phone-wrap {
    width: 210px;
    flex-shrink: 0;
    animation: adpFloat 4s ease-in-out infinite;
  }
  @keyframes adpFloat {
    0%, 100% { transform: translateY(0) rotate(-2deg); }
    50%       { transform: translateY(-12px) rotate(2deg); }
  }
  .adp-phone-frame {
    background: linear-gradient(145deg, #fff, #f3f0ff);
    border: 1.5px solid var(--border);
    border-radius: 34px;
    padding: 14px 10px;
    box-shadow: 0 24px 64px var(--shadow), 0 4px 16px #c4b5fd30, inset 0 1px 0 #fff;
  }
  .adp-phone-notch {
    width: 56px; height: 5px;
    background: #e4e0f7;
    border-radius: 100px;
    margin: 0 auto 12px;
  }
  .adp-phone-screen {
    background: linear-gradient(145deg, var(--bg3), #ede9fe);
    border-radius: 24px;
    aspect-ratio: 9/16;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    position: relative;
    overflow: hidden;
  }
  .adp-phone-screen::before {
    content: '';
    position: absolute; inset: 0;
    background: radial-gradient(circle at 50% 35%, #c4b5fd50, transparent 60%);
  }
  .adp-phone-icon {
    width: 62px; height: 62px;
    border-radius: 18px;
    background: linear-gradient(135deg, var(--acc), #7c6ff7);
    display: flex; align-items: center; justify-content: center;
    font-size: 1.7rem;
    position: relative; z-index: 1;
    box-shadow: 0 8px 24px #5b4ef540;
    color: #fff;
  }
  .adp-phone-name {
    font-family: 'Syne', sans-serif;
    font-size: .78rem; font-weight: 700;
    color: var(--txt);
    position: relative; z-index: 1;
  }
  .adp-phone-ver {
    font-size: .62rem; color: var(--txt3);
    position: relative; z-index: 1;
  }

  /* Download card */
  .adp-dl-card {
    background: linear-gradient(135deg, var(--acc) 0%, #7c6ff7 100%);
    border-radius: 22px;
    padding: 2rem 2.2rem;
    display: flex;
    align-items: center;
    gap: 2rem;
    flex-wrap: wrap;
    margin-top: 2.5rem;
    box-shadow: 0 16px 50px #5b4ef530;
    position: relative;
    overflow: hidden;
    animation: adpFadeUp .6s .28s ease both;
  }
  .adp-dl-card::before {
    content: '';
    position: absolute; top: -50px; right: -30px;
    width: 200px; height: 200px;
    border-radius: 50%;
    background: rgba(255,255,255,.07);
  }
  .adp-dl-card::after {
    content: '';
    position: absolute; bottom: -60px; right: 80px;
    width: 130px; height: 130px;
    border-radius: 50%;
    background: rgba(255,255,255,.05);
  }
  .adp-dl-emoji { font-size: 2.8rem; z-index: 1; }
  .adp-dl-info { flex: 1; min-width: 200px; z-index: 1; }
  .adp-dl-info h3 { font-size: 1.3rem; font-weight: 700; color: #fff; margin-bottom: .2rem; }
  .adp-dl-info p  { color: rgba(255,255,255,.72); font-size: .88rem; margin: 0; }
  .adp-dl-tags { display: flex; gap: .6rem; margin-top: .7rem; flex-wrap: wrap; }
  .adp-dl-tag {
    background: rgba(255,255,255,.15);
    border-radius: 8px; padding: 3px 11px;
    font-size: .76rem; color: rgba(255,255,255,.9);
  }
  .adp-btn-dl {
    display: flex; align-items: center; gap: 9px;
    background: #fff; color: var(--acc);
    font-family: 'Syne', sans-serif; font-weight: 700; font-size: .95rem;
    border: none; border-radius: 14px; padding: .9rem 1.8rem;
    cursor: pointer; text-decoration: none; white-space: nowrap;
    transition: transform .18s, box-shadow .18s;
    box-shadow: 0 6px 24px rgba(0,0,0,.15);
    z-index: 1;
  }
  .adp-btn-dl:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 36px rgba(0,0,0,.2);
    color: var(--acc);
  }
  .adp-btn-dl i { font-size: 1.25rem; }

  /* Section labels */
  .adp-sec-label {
    font-size: .72rem; font-weight: 700; letter-spacing: .1em;
    text-transform: uppercase; color: var(--acc); margin-bottom: .4rem;
  }
  .adp-sec-title { font-size: 1.75rem; font-weight: 700; color: var(--txt); margin-bottom: .35rem; }
  .adp-sec-sub   { font-size: .92rem; color: var(--txt2); margin-bottom: 2rem; }

  /* Step cards */
  .adp-step-card {
    background: var(--bg2);
    border: 1.5px solid var(--border);
    border-radius: 16px; padding: 1.4rem 1.5rem;
    display: flex; gap: 1.2rem; align-items: flex-start;
    margin-bottom: .9rem;
    transition: border-color .2s, box-shadow .2s, transform .2s;
    cursor: default;
  }
  .adp-step-card:hover {
    border-color: var(--acc-light2);
    box-shadow: 0 8px 28px var(--shadow);
    transform: translateY(-2px);
  }
  .adp-step-num {
    min-width: 42px; height: 42px;
    border-radius: 12px;
    background: var(--acc-light);
    display: flex; align-items: center; justify-content: center;
    font-family: 'Syne', sans-serif; font-weight: 800; font-size: 1rem;
    color: var(--acc); flex-shrink: 0;
    transition: background .2s, color .2s;
  }
  .adp-step-card:hover .adp-step-num { background: var(--acc); color: #fff; }
  .adp-step-body h4  { font-size: .97rem; font-weight: 600; color: var(--txt); margin-bottom: .3rem; }
  .adp-step-body p   { font-size: .86rem; color: var(--txt2); line-height: 1.65; margin: 0; }
  .adp-code-pill {
    display: inline-block;
    background: var(--acc-light); border: 1px solid var(--acc-light2);
    border-radius: 8px; padding: 3px 10px;
    font-family: monospace; font-size: .8rem; color: var(--acc);
    margin-top: .5rem;
  }

  /* Alert cards */
  .adp-alert-ok {
    background: #f0fdf4; border: 1.5px solid #bbf7d0;
    border-radius: 16px; padding: 1.4rem 1.5rem; height: 100%;
  }
  .adp-alert-warn {
    background: #fffbeb; border: 1.5px solid #fde68a;
    border-radius: 16px; padding: 1.4rem 1.5rem; height: 100%;
  }
  .adp-alert-ok h4   { color: #14532d; font-size: .97rem; font-weight: 600; margin-bottom: .4rem; }
  .adp-alert-warn h4 { color: #78350f; font-size: .97rem; font-weight: 600; margin-bottom: .4rem; }
  .adp-alert-ok p    { color: #166534; font-size: .85rem; line-height: 1.65; margin: 0; }
  .adp-alert-warn ul { color: #92400e; font-size: .85rem; line-height: 1.65; padding-left: 1.1rem; margin: 0; }

  /* Req grid */
  .adp-req-item {
    background: var(--bg2); border: 1.5px solid var(--border);
    border-radius: 14px; padding: 1.3rem; text-align: center;
    transition: border-color .2s, box-shadow .2s;
  }
  .adp-req-item:hover {
    border-color: var(--acc-light2);
    box-shadow: 0 4px 18px var(--shadow);
  }
  .adp-req-item i      { font-size: 1.8rem; color: var(--acc); margin-bottom: .7rem; display: block; }
  .adp-req-item strong { display: block; font-size: .95rem; font-weight: 600; color: var(--txt); margin-bottom: .15rem; }
  .adp-req-item span   { font-size: .78rem; color: var(--txt3); }

  /* Footer */
  .adp-footer {
    margin-top: 5rem; padding-top: 2rem;
    border-top: 1.5px solid var(--border);
    text-align: center; color: var(--txt3); font-size: .82rem;
  }
  .adp-footer a { color: var(--acc); text-decoration: none; }
  .adp-footer a:hover { text-decoration: underline; }

  /* Section animations */
  .adp-s1 { animation: adpFadeUp .6s .34s ease both; }
  .adp-s2 { animation: adpFadeUp .6s .40s ease both; }
  .adp-s3 { animation: adpFadeUp .6s .46s ease both; }
  .adp-s4 { animation: adpFadeUp .6s .52s ease both; }

  @keyframes adpFadeDown {
    from { opacity: 0; transform: translateY(-16px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes adpFadeUp {
    from { opacity: 0; transform: translateY(16px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  @keyframes adpPulse {
    0%, 100% { transform: scale(1); }
    50%       { transform: scale(1.5); opacity: .6; }
  }

  @media (max-width: 640px) {
    .adp-phone-wrap { display: none; }
    .adp-dl-card    { flex-direction: column; }
  }
`;

const steps = [
  {
    icon: "bi-cloud-arrow-down",
    title: "APK faylni yuklab oling",
    desc: 'Yuqoridagi tugmani bosib, APK faylni qurilmangiz xotirasiga saqlang. Brauzer ruxsat so\'rasa, "Ruxsat berish" tugmasini bosing.',
    extra: null,
  },
  {
    icon: "bi-gear",
    title: "Sozlamalarni oching",
    desc: "Telefonizda Sozlamalar → Xavfsizlik yoki Maxfiylik bo'limiga o'ting.",
    extra: "Sozlamalar → Xavfsizlik → Noma'lum manbalar",
  },
  {
    icon: "bi-toggle-on",
    title: "Noma'lum manbalardan ruxsat bering",
    desc: '"Noma\'lum manbalardan ilovalar o\'rnatish" tugmasini yoqing. Android 8.0+ da bu sozlama brauzeringiz uchun alohida bo\'ladi.',
    extra: null,
  },
  {
    icon: "bi-folder2-open",
    title: "APK faylni ishga tushiring",
    desc: "Bildirishnomalar panelidan yoki Fayl menejeri → Yuklamalar papkasidan MyApp.apk faylni topib bosing.",
    extra: null,
  },
  {
    icon: "bi-check-circle",
    title: "O'rnatishni tasdiqlang",
    desc: 'Ekranda "O\'rnatish" tugmasini bosing. Bir necha soniyadan so\'ng ilova o\'rnatiladi va "Ochish" tugmasi paydo bo\'ladi.',
    extra: null,
    green: true,
  },
];

const requirements = [
  { icon: "bi-android2",    label: "Android 12.0+",  sub: "Marshmallow va yuqori" },
  { icon: "bi-cpu",         label: "2 GB RAM",       sub: "Tavsiya: 3 GB+" },
  { icon: "bi-hdd",         label: "50 MB",          sub: "Bepul xotira" },
  { icon: "bi-wifi",        label: "Internet",       sub: "Dastlabki sozlash uchun" },
];

export default function MobileApp() {
  const [hoveredStep, setHoveredStep] = useState(null);

  return (
    <>
      <style>{styles}</style>
      <div className="adp-root" style={{ padding: '30px 30px 100px 30px', marginBottom: '60px', borderRadius: '15px', backdropFilter: 'blur(10px)' }}>
        <div className="adp-page-bg" />
        <div className="adp-wrap">
          <Container>

            {/* ── HERO ── */}
            <Row className="align-items-center g-4 mb-0">
              <Col xs={12} md={7}>
                <div className="adp-badge-pill">
                  <span className="dot" />
                  Yangi versiya mavjud
                </div>
                <h1 className="adp-hero-title">
                  Ilovangizni<br />
                  <span>yuklab oling</span>
                </h1>
                <p className="adp-hero-sub">
                  To'g'ridan-to'g'ri qurilmangizga o'rnating — Play Market kerak emas.
                  Bir necha oddiy qadam bilan tayyor.
                </p>
                <div className="adp-stats-row">
                  {[
                    { num: "4.8 ★", lbl: "Reyting" },
                    { num: "50K+",  lbl: "Foydalanuvchi" },
                    { num: "75.2 MB", lbl: "Hajm" },
                  ].map((s) => (
                    <div key={s.lbl}>
                      <div className="adp-stat-num">{s.num}</div>
                      <div className="adp-stat-lbl">{s.lbl}</div>
                    </div>
                  ))}
                </div>
              </Col>
              <Col xs={12} md={5} className="d-flex justify-content-center">
                <div className="adp-phone-wrap">
                  <div className="adp-phone-frame">
                    <div className="adp-phone-notch" />
                    <div className="adp-phone-screen">
                      <div className="adp-phone-icon">
                        <i className="bi bi-stars" />
                      </div>
                      <div className="adp-phone-name">Familybook</div>
                      <div className="adp-phone-ver">v1.0.1</div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>

            {/* ── DOWNLOAD CARD ── */}
            <div className="adp-dl-card">
              <div className="adp-dl-emoji">📱</div>
              <div className="adp-dl-info">
                <h3>
                  Familybook.apk{" "}
                  <span style={{
                    background: "rgba(255,255,255,.18)", borderRadius: 100,
                    padding: "3px 11px", fontSize: ".72rem",
                    fontWeight: 500, color: "rgba(255,255,255,.85)", marginLeft: 6,
                  }}>
                    v1.0.1
                  </span>
                </h3>
                <p>Android 12.0 va undan yuqori versiyalar uchun</p>
                <div className="adp-dl-tags">
                  {[
                    { icon: "bi-shield-check", text: "Xavfsiz" },
                    { icon: "bi-file-zip",     text: "75.3 MB" },
                    { icon: "bi-calendar3",    text: "2026" },
                  ].map((t) => (
                    <span className="adp-dl-tag" key={t.text}>
                      <i className={`bi ${t.icon} me-1`} />{t.text}
                    </span>
                  ))}
                </div>
              </div>
              <a href={programm} download  className="adp-btn-dl">
                <i className="bi bi-cloud-arrow-down-fill" />
                APK Yuklab olish
              </a>
            </div>

            {/* ── STEPS ── */}
            <div className="mt-5 adp-s1">
              <div className="adp-sec-label">Ko'rsatma</div>
              <h2 className="adp-sec-title">O'rnatish bosqichlari</h2>
              <p className="adp-sec-sub">Quyidagi 5 ta oddiy qadamni bajaring</p>

              {steps.map((step, i) => (
                <div
                  key={i}
                  className="adp-step-card"
                  onMouseEnter={() => setHoveredStep(i)}
                  onMouseLeave={() => setHoveredStep(null)}
                >
                  <div className="adp-step-num">{i + 1}</div>
                  <div className="adp-step-body">
                    <h4>
                      <i
                        className={`bi ${step.icon} me-2`}
                        style={{ color: step.green ? "var(--acc3)" : "var(--acc)" }}
                      />
                      {step.title}
                    </h4>
                    <p>{step.desc}</p>
                    {step.extra && (
                      <span className="adp-code-pill">{step.extra}</span>
                    )}
                  </div>
                </div>
              ))}
            </div>

            {/* ── ALERTS ── */}
            <div className="mt-5 adp-s2">
              <Row className="g-3">
                <Col md={7}>
                  <div className="adp-alert-ok">
                    <div style={{ fontSize: "1.4rem", color: "#16a34a", marginBottom: ".7rem" }}>
                      <i className="bi bi-shield-check-fill" />
                    </div>
                    <h4>Bu fayl xavfsizmi?</h4>
                    <p>
                      Ha, ilova to'liq xavfsiz va tekshirilgan. APK fayllar rasmiy
                      Play Market orqali tarqatilmasa ham, ular 100% ishonchli bo'lishi
                      mumkin. Bu ilovani biz to'g'ridan-to'g'ri taqdim etamiz.
                    </p>
                  </div>
                </Col>
                <Col md={5}>
                  <div className="adp-alert-warn">
                    <div style={{ fontSize: "1.4rem", color: "#d97706", marginBottom: ".7rem" }}>
                      <i className="bi bi-exclamation-triangle-fill" />
                    </div>
                    <h4>Diqqat!</h4>
                    <ul>
                      <li>Faqat shu sahifadan yuklab oling</li>
                      <li>Uchinchi tomon saytlardan yuklamang</li>
                      <li>O'rnatgandan so'ng ruxsatni yopib qo'ying</li>
                    </ul>
                  </div>
                </Col>
              </Row>
            </div>

            {/* ── REQUIREMENTS ── */}
            <div className="mt-5 adp-s3">
              <div className="adp-sec-label">Texnik</div>
              <h2 className="adp-sec-title">Minimal talablar</h2>
              <p className="adp-sec-sub">Ilovani ishlatish uchun zarur bo'lgan imkoniyatlar</p>
              <Row className="g-3">
                {requirements.map((r) => (
                  <Col key={r.label} xs={6} md={3}>
                    <div className="adp-req-item">
                      <i className={`bi ${r.icon}`} />
                      <strong>{r.label}</strong>
                      <span>{r.sub}</span>
                    </div>
                  </Col>
                ))}
              </Row>
            </div>
          </Container>
        </div>
      </div>
    </>
  );
}
